// @flow

import * as Immutable                           from 'immutable';
import createCachedSelector, { LruObjectCache } from 're-reselect';
import type { CookieType }                      from '../config/cookiesConfig';
import cookiesConfig                            from '../config/cookiesConfig';
import type { State }                           from '../store';

const selectState = (state: State): Immutable.Map<*, *> => state.get('cookieSettings', Immutable.Map());

export const selectUserCookieSettings = (state: State) => selectState(state).get('userSettings') || Immutable.Map();

export const selectComponentsState = (state: State) => selectState(state).get('components') || Immutable.Map();

export const selectCookieBlockedModalState = (state: State) => selectComponentsState(state).get('cookieBlockedModal') || Immutable.Map();


export const selectIsCookieTypeEnabled: (state: State, {cookieType: CookieType}) => boolean = createCachedSelector(
  [
    selectUserCookieSettings,
    (state, {cookieType}) => cookieType,
  ],
  (userCookieSettings, cookieType) => !!userCookieSettings.getIn([cookieType, 'enabled'], false),
)(
  // cacheKey resolver
  (state, {cookieType}) => cookieType,

  // Config
  {cacheObject: new LruObjectCache({cacheSize: Object.keys(cookiesConfig).length})},
);


export const selectCookieBlockedModalCookieTypes = (state: State) => selectCookieBlockedModalState(state).get('displayForCookieType');



// WEBPACK FOOTER //
// ./src/selectors/cookieSettingsSelectors.js